import Gallery from 'react-image-gallery';

import IconButton from '@mui/material/IconButton';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import FullscreenOutlinedIcon from '@mui/icons-material/FullscreenOutlined';
import FullscreenExitOutlinedIcon from '@mui/icons-material/FullscreenExitOutlined';

import { Styled } from './index.styled';

import type { Theme } from '@mui/material/styles';

interface Props {
  pictures?: UCM.CandidateImage[];
  width?: number;
  height?: number;
}

const SliderIconStyles = { color: '#fff', fontSize: '12px' };
const FullScreenIconStyles = {
  color: '#fff',
  fontSize: (theme: Theme) => theme.spacing(2.75),
};
const SliderButtonStyles = { position: 'absolute', bottom: 0, zIndex: 1 };
const FullScreenButton = { position: 'absolute', top: 0, right: 0, zIndex: 1 };

export const ImageGallery = ({
  pictures,
  height = 190,
  width = 150,
}: Props) => {
  if (!pictures) return null;

  return (
    <Styled.Container width={width} height={height}>
      <Gallery
        items={pictures}
        showThumbnails={false}
        showPlayButton={false}
        renderLeftNav={(onClick, disabled) => (
          <IconButton
            onClick={onClick}
            disabled={disabled}
            sx={{ ...SliderButtonStyles, left: 0 }}
          >
            <ArrowBackOutlinedIcon sx={SliderIconStyles} />
          </IconButton>
        )}
        renderRightNav={(onClick, disabled) => (
          <IconButton
            onClick={onClick}
            disabled={disabled}
            sx={{ ...SliderButtonStyles, right: 0 }}
          >
            <ArrowForwardOutlinedIcon sx={SliderIconStyles} />
          </IconButton>
        )}
        renderFullscreenButton={(onClick, isFullscreen) => (
          <IconButton onClick={onClick} sx={FullScreenButton}>
            {isFullscreen ? (
              <FullscreenExitOutlinedIcon sx={FullScreenIconStyles} />
            ) : (
              <FullscreenOutlinedIcon sx={SliderIconStyles} />
            )}
          </IconButton>
        )}
      />
    </Styled.Container>
  );
};
